import { useToast, UseToastOptions } from "@chakra-ui/react";

export const useToastbar = () => {
  const defaultOptions: UseToastOptions = {
    duration: 9000,
    isClosable: true,
  };
  return useToast(defaultOptions);
};
